import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { loadRuntimeConfig } from "./config/runtimeConfig";
import "./styles/tokens.css";
import "./styles/globals.css";

const container = document.getElementById("root");
const root = createRoot(container);

const startApp = async () => {
  await loadRuntimeConfig();
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

startApp();
